import { mixpanel } from '@fiverr-private/obs';

export const sendClickEventToMixPanel = (eventParams = {}) => {
    const { eventName, ...properties } = eventParams;
    mixpanel.track(eventName, properties);
};
